import React, { useState, useEffect } from 'react';
import JsBarcode from 'jsbarcode';
import { createCanvas } from 'canvas';
import '../styles/armsform.css'; // Import the dedicated CSS file

const LocalDomicileForm = () => {
    const [formData, setFormData] = useState({
        token_id: 'E Local(D) - ',
        local_no: '',
        date: '',
        name: '',
        father_name: '',
        cnic: '',
        phone_no: '',
        status: '',
        address: '',
        district: '',
        province: '',
        date_of_arrival: '',
        marital_status: '',
        wife_name: '',
        husband_name: '',
        sons_ages: '',
        daughters_ages: '',
        trade_occupation: '',
        marks_of_identification: ''
    });

    const [message, setMessage] = useState(null);
    const [barcodeImage, setBarcodeImage] = useState(null);
    const [showPopup, setShowPopup] = useState(false);

    const generateBarcode = (tokenId) => {
        const canvas = createCanvas();
        JsBarcode(canvas, tokenId, { format: "CODE128" });
        return canvas.toDataURL("image/png");
    };

    useEffect(() => {
        if (formData.token_id) {
            const barcodeImage = generateBarcode(formData.token_id);
            setBarcodeImage(barcodeImage);
        } else {
            setBarcodeImage(null);
        }
    }, [formData.token_id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.token_id || !formData.local_no || !formData.date) {
            setMessage("Please fill in the required fields: Token ID, Local No, and Date.");
            return;
        }

        try {
            const response = await fetch('https://chaman.gob.pk/eac_backend/localdom.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    action: 'add',
                    ...formData,
                    barcode: barcodeImage
                })
            });

            const textResponse = await response.text();
            console.log(textResponse);

            try {
                const result = JSON.parse(textResponse);
                if (result.status === "success") {
                    setMessage(result.message);
                    setFormData({
                        token_id: 'E Local(D) - ',
                        local_no: '',
                        date: '',
                        name: '',
                        father_name: '',
                        cnic: '',
                        phone_no: '',
                        status: '',
                        address: '',
                        district: '',
                        province: '',
                        date_of_arrival: '',
                        marital_status: '',
                        wife_name: '',
                        husband_name: '',
                        sons_ages: '',
                        daughters_ages: '',
                        trade_occupation: '',
                        marks_of_identification: ''
                    });
                    setBarcodeImage(null);
                    setShowPopup(true);
                    setTimeout(() => setShowPopup(false), 2000);
                } else {
                    setMessage("Error: " + result.message);
                }
            } catch (error) {
                console.error("Error parsing response as JSON:", error);
                setMessage("Received unexpected response from the server. Please try again.");
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            setMessage("An error occurred while submitting the form. Please try again.");
        }
    };

    return (
        <div className="lc-form-container">
            <form onSubmit={handleSubmit} className="lc-form">
                <div className="lc-left-section">
                    <div className="lc-form-group">
                        <label className="lc-label">Token ID</label>
                        <div className="lc-input-container">
                            <input 
                                type="text" 
                                name="token_id" 
                                value={formData.token_id} 
                                onChange={handleChange} 
                                className="lc-input"
                                required 
                            />
                        </div>
                    </div>

                    <div className="lc-form-group">
                        <label className="lc-label">Domicile No:</label>
                        <div className="lc-input-container">
                            <input 
                                type="text" 
                                name="local_no" 
                                value={formData.local_no} 
                                onChange={handleChange} 
                                className="lc-input"
                                required 
                            />
                        </div>
                    </div>

                    <div className="lc-form-group">
                        <label className="lc-label">Date:</label>
                        <div className="lc-input-container">
                            <input 
                                type="date" 
                                name="date" 
                                value={formData.date} 
                                onChange={handleChange} 
                                className="lc-input"
                                required 
                            />
                        </div>
                    </div>

                    <div className="lc-form-group">
                        <label className="lc-label">Name:</label>
                        <div className="lc-input-container">
                            <input 
                                type="text" 
                                name="name" 
                                value={formData.name} 
                                onChange={handleChange} 
                                className="lc-input"
                            />
                        </div>
                    </div>

                    <div className="lc-form-group">
                        <label className="lc-label">Father Name:</label>
                        <div className="lc-input-container">
                            <input 
                                type="text" 
                                name="father_name" 
                                value={formData.father_name} 
                                onChange={handleChange} 
                                className="lc-input"
                            />
                        </div>
                    </div>

                    <div className="lc-form-group">
                        <label className="lc-label">CNIC:</label>
                        <div className="lc-input-container">
                            <input 
                                type="text" 
                                name="cnic" 
                                value={formData.cnic} 
                                onChange={handleChange} 
                                className="lc-input"
                            />
                        </div>
                    </div>

                    <div className="lc-form-group">
                        <label className="lc-label">Phone No:</label>
                        <div className="lc-input-container">
                            <input 
                                type="text" 
                                name="phone_no" 
                                value={formData.phone_no} 
                                onChange={handleChange} 
                                className="lc-input"
                            />
                        </div>
                    </div>

                    <div className="lc-form-group">
                        <label className="lc-label">Status:</label>
                        <div className="lc-input-container">
                            <select 
                                name="status" 
                                value={formData.status} 
                                onChange={handleChange}
                                className="lc-select"
                                required
                            >
                                <option value="" disabled>Select Status</option>
                                <option value="Received">Received</option>
                                <option value="Ready">Ready</option>
                            </select>
                        </div>
                    </div>

                    <div className="lc-form-group">
                        <label className="lc-label">Address:</label>
                        <div className="lc-input-container">
                            <input 
                                type="text" 
                                name="address" 
                                value={formData.address} 
                                onChange={handleChange} 
                                className="lc-input"
                            />
                        </div>
                    </div>

                    <div className="lc-form-group">
                        <label className="lc-label">District:</label>
                        <div className="lc-input-container">
                            <input 
                                type="text" 
                                name="district" 
                                value={formData.district} 
                                onChange={handleChange} 
                                className="lc-input"
                            />
                        </div>
                    </div>
                </div>
                
                <div className="lc-right-section">
                    <div className="lc-form-group">
                        <label className="lc-label">Province:</label>
                        <div className="lc-input-container">
                            <select 
                                name="province" 
                                value={formData.province} 
                                onChange={handleChange}
                                className="lc-select"
                                required
                            >
                                <option value="" disabled>Select Province</option>
                                <option value="Balochistan">Balochistan</option>
                                <option value="KPK">KPK</option>
                                <option value="Sindh">Sindh</option>
                                <option value="Punjab">Punjab</option>
                            </select>
                        </div>
                    </div>

                    <div className="lc-form-group">
                        <label className="lc-label">Date of Arrival:</label>
                        <div className="lc-input-container">
                            <input 
                                type="date" 
                                name="date_of_arrival" 
                                value={formData.date_of_arrival} 
                                onChange={handleChange} 
                                className="lc-input"
                            />
                        </div>
                    </div>

                    <div className="lc-form-group">
                        <label className="lc-label">Marital Status:</label>
                        <div className="lc-input-container">
                            <select 
                                name="marital_status" 
                                value={formData.marital_status} 
                                onChange={handleChange}
                                className="lc-select"
                                required
                            >
                                <option value="" disabled>Select Marital Status</option>
                                <option value="Married">Married</option>
                                <option value="Single">Single</option>
                            </select>
                        </div>
                    </div>

                    <div className="lc-form-group">
                        <label className="lc-label">Wife's Name:</label>
                        <div className="lc-input-container">
                            <input 
                                type="text" 
                                name="wife_name" 
                                value={formData.wife_name} 
                                onChange={handleChange} 
                                className="lc-input"
                            />
                        </div>
                    </div>

                    <div className="lc-form-group">
                        <label className="lc-label">Husband's Name:</label>
                        <div className="lc-input-container">
                            <input 
                                type="text" 
                                name="husband_name" 
                                value={formData.husband_name} 
                                onChange={handleChange} 
                                className="lc-input"
                            />
                        </div>
                    </div>

                    <div className="lc-form-group">
                        <label className="lc-label">Sons' Ages:</label>
                        <div className="lc-input-container">
                            <input 
                                type="text" 
                                name="sons_ages" 
                                value={formData.sons_ages} 
                                onChange={handleChange} 
                                className="lc-input"
                            />
                        </div>
                    </div>

                    <div className="lc-form-group">
                        <label className="lc-label">Daughters' Ages:</label>
                        <div className="lc-input-container">
                            <input 
                                type="text" 
                                name="daughters_ages" 
                                value={formData.daughters_ages} 
                                onChange={handleChange} 
                                className="lc-input"
                            />
                        </div>
                    </div>

                    <div className="lc-form-group">
                        <label className="lc-label">Trade/Occupation:</label>
                        <div className="lc-input-container">
                            <input 
                                type="text" 
                                name="trade_occupation" 
                                value={formData.trade_occupation} 
                                onChange={handleChange} 
                                className="lc-input"
                            />
                        </div>
                    </div>

                    <div className="lc-form-group">
                        <label className="lc-label">Marks of Identification:</label>
                        <div className="lc-input-container">
                            <textarea 
                                name="marks_of_identification" 
                                value={formData.marks_of_identification} 
                                onChange={handleChange}
                                className="lc-input"
                            ></textarea>
                        </div>
                    </div>
                </div>
                
            </form>
                <button type="submit" className="lc-submit-btn">Submit</button>

            {showPopup && (
                <div className="lc-popup">
                    Data saved successfully!
                </div>
            )}
        </div>
    );
};

export default LocalDomicileForm;